/* @flow */

export default class InformAdminRequest {
    companyId: number;
  
    constructor(companyId: number) {
      this.companyId = companyId;
    }
  }
  